import React from 'react';
import DocumentTitle from 'react-document-title';
import './signup3.css'

export default class SignUpPage3 extends React.Component {

    constructor(props) {
        super(props);
        this.state = props.data
    }

    getData() {
        return this.state
    }

    render() {
        return (
            <DocumentTitle title="Khula - Billing">
                <table className="uk-table uk-table-hover uk-table-responsive uk-table-middle uk-table-divider" style={{width:"50%",margin:"auto"}}>
                    <tr>
                        <th>Company</th>
                        <th>Country</th>
                    </tr>
                    <tr>
                        <td className="uk-table-shrink">Name</td>
                        <td className="uk-text-nowrap">{this.state.client_name}</td>
                    </tr>
                    <tr>
                        <td className="uk-table-shrink">Email</td>
                        <td className="uk-text-nowrap">{this.state.email}</td>
                    </tr>
                    <tr>
                        <td className="uk-table-shrink">Phone</td>
                        <td className="uk-text-nowrap">{this.state.phone}</td>
                    </tr>
                    <tr>
                        <td className="uk-table-shrink">Address</td>
                        <td className="uk-text-nowrap">{this.state.location}</td>
                    </tr>
                    <tr>
                        <td className="uk-table-shrink">Vat Number</td>
                        <td className="uk-text-nowrap">{this.state.vat}</td>
                    </tr>
                    <tr>
                        <td className="uk-table-shrink">Buying</td>
                        <td className="uk-text-nowrap">{this.state.buying}</td>
                    </tr>
                </table>
            </DocumentTitle>

        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/SignUpPages/Page4.js